import React from 'react'
import { MdLabelImportant } from "react-icons/md";
const Learn = ({selectedCourse}) => {
  return (
     <div className='w-full py-4'>
        <h2 className='text-[#22BEFF] text-2xl font-bold'>কোর্সটি করে যা শিখবেন</h2>
        <div className='w-full border border-[#22BEFF33] mt-[1rem] rounded-md grid grid-cols-1 gap-4 p-4'>

            {
                selectedCourse?.content_outcome.map((items,index)=>(

                <div key={index} className='flex items-center'>
                    <MdLabelImportant className='text-[#22BEFF]'/>
                    <p className='text-xl text-gray-400'>{items}</p>
        
                </div>

                ))
            }
       
        </div>
    </div>
  )
}

export default Learn